module.exports = __webpack_public_path__ + "static/media/wd_tmpl.1aa94f4f.svg";